import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Actions - imported
import { toggleSideNav, goBack } from '../../actions/navActions';

// Components
import { Button } from '@material-ui/core';
import Spinner from '../common/Spinner';
import Ad_Block from './Ad_Block';
import Available_Funds from '../common/Available_Funds';
import Avatar_For_Headers from '../common/Avatar_For_Headers';

// Icons
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const Ads_List = ({
    auth: {
        user,
        loading
    },
    nav: {
        sideNav
    },
    ad,
    history,
    goBack
}) => {

    // Orders List
    const [adList, setAdList] = useState([]);
    const [gotAds, setGotAds] = useState(false);

    useEffect(() => {

        // Update the header animation based on the sideNav state
        if(sideNav) {
            document.getElementById('feed-header')?.classList.remove("active");
            return "feed__header";
        } else {
            setTimeout(() => {
                document.getElementById('feed-header')?.classList.add("active");
            }, 700)
        }
    }, [sideNav])

    useEffect(() => {

        renderAdList();
    }, [ad.ads]);

    const renderAdList = () => {
        setAdList([]);

        if(ad.ads === null) {
            setAdList([(
                <Spinner />
            )])
        }
        else { 
            if(ad.ads.length > 0) {

                ad.ads.map(ad_obj => {
                    setAdList(adList => [...adList, (
                        <Ad_Block
                            ad_details={ad_obj}
                        />
                    )])
                });

                setGotAds(true);
            } else {
                setAdList([(
                    <div className="no-rides">
                        <h1>No Ads</h1>
                    </div>
                )])
            }
        } 
    }

    return (
        <div className="feed">
            {/**Header */}
            <div className="feed__header" id="feed-header">
                <div style={{display: 'flex', alignItems: 'center', paddingBottom: '10px', boxSizing: 'border-box'}}>
                    {/* Left arrow Icon */}
                    <div onClick={goBack} style={{marginRight: '10px'}} className="shopFeed__backBtn">
                        <div>
                            <ArrowBackIcon />
                        </div>
                    </div>
                    <h2>My Ads</h2>

                    <div style={{right:'20px', position:'absolute', display: 'flex'}}>

                        {/* --- Avatar Icon --- */}
                        <Avatar_For_Headers />
                        {/* --- END: Avatar Icon --- */}
                    </div>
                </div>
                
            </div>

            {loading ? <Spinner /> : (
                <Fragment>
                    {ad.ads?.length > 0 && <Available_Funds showLink />}

                    {adList}

                    {/* Spacer */}
                    <div className="no-rides"></div>
                </Fragment>
            )}
            
        </div>
    )
}

Ads_List.propTypes = {
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    ad: PropTypes.object.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav,
    auth: state.auth,
    ad: state.ad
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    toggleSideNav,
    goBack 
})(Ads_List);